import { Clock, Timer } from 'lucide-react';
import { formatCSTTime } from '../../utils/time';
import { TaskTimeRecord } from '../../types/workOrders';

interface TaskTimestampsProps {
  timeRecords?: TaskTimeRecord[];
  currentStartTime?: number | null;
  elapsedTime?: number;
  isCompleted: boolean;
}

export function TaskTimestamps({ 
  timeRecords = [], 
  currentStartTime, 
  elapsedTime = 0,
  isCompleted 
}: TaskTimestampsProps) {
  const formatElapsedTime = (ms: number) => {
    const seconds = Math.floor(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    return `${hours}h ${minutes % 60}m ${seconds % 60}s`;
  };

  // For active tasks
  if (currentStartTime && !isCompleted) {
    return (
      <div className="mt-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg p-3 space-y-2 border border-blue-100 dark:border-blue-800">
        <div className="flex items-center gap-2 text-blue-700 dark:text-blue-300 text-sm">
          <Clock className="h-4 w-4" />
          <span>Started: {formatCSTTime(new Date(currentStartTime))}</span>
        </div>
        <div className="flex items-center gap-2 text-blue-700 dark:text-blue-300 text-sm">
          <Timer className="h-4 w-4" />
          <span>Elapsed: {formatElapsedTime(elapsedTime)}</span>
        </div>
      </div>
    );
  }

  // For completed tasks with time records
  if (timeRecords.length > 0 && isCompleted) {
    return (
      <div className="mt-3 space-y-3">
        {timeRecords.map((record, index) => {
          const duration = (record.end_time - record.start_time) * 1000;
          const recordNumber = timeRecords.length > 1 ? ` (${index + 1}/${timeRecords.length})` : '';
          
          return (
            <div 
              key={`${record.start_time}-${record.end_time}`} 
              className="bg-green-50 dark:bg-green-900/20 rounded-lg p-3 space-y-2 border border-green-100 dark:border-green-800"
            >
              <div className="flex items-center gap-2 text-green-700 dark:text-green-300 text-sm">
                <Clock className="h-4 w-4" />
                <span>Started{recordNumber}: {formatCSTTime(new Date(record.start_time * 1000))}</span>
              </div>
              <div className="flex items-center gap-2 text-green-700 dark:text-green-300 text-sm">
                <Clock className="h-4 w-4" />
                <span>Completed: {formatCSTTime(new Date(record.end_time * 1000))}</span>
              </div>
              <div className="flex items-center gap-2 text-green-700 dark:text-green-300 text-sm">
                <Timer className="h-4 w-4" />
                <span>Duration: {formatElapsedTime(duration)}</span>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  return null;
}